import {QueryString} from "./querystring.js";

export const Location = {

  querystring: QueryString

};